export default __webpack_public_path__ + "static/media/minigame_banner_1.72be9574.png";